// src/components/RoleSelector.jsx
import React from "react";

const ROLES = [
  {
    id: "startup",
    title: "Startup",
    description: "Browse challenges and submit solutions",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    ),
  },
  {
    id: "corporation",
    title: "Business Owner",
    description: "Post challenges and review solutions",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <path d="M3 21h18" />
        <path d="M5 21V7l8-4v18" />
        <path d="M19 21V11l-6-4" />
        <path d="M9 9v.01" />
        <path d="M9 12v.01" />
        <path d="M9 15v.01" />
        <path d="M9 18v.01" />
      </svg>
    ),
  },
];

export default function RoleSelector({ value, onChange, name = "account-role" }) {
  return (
    <div className="role-selector" role="radiogroup" aria-label="Account type">
      {ROLES.map(role => {
        const selected = value === role.id;
        return (
          <button
            key={role.id}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`role-card${selected ? " is-selected" : ""}`}
            onClick={() => onChange(role.id)}
          >
            <span className="role-card-icon">{role.icon}</span>
            <span className="role-card-copy">
              <span className="role-card-title">{role.title}</span>
              <span className="role-card-desc">{role.description}</span>
            </span>
            <span className="role-card-check" aria-hidden="true">
              {selected ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              ) : null}
            </span>
            <input type="radio" name={name} value={role.id} checked={selected} readOnly tabIndex={-1} className="sr-only" />
          </button>
        );
      })}
    </div>
  );
}
